import React from "react";
import UserField from "../misc/UserField";
import { connect } from "react-redux";
import { Header, Grid, Modal, Button, Icon } from "semantic-ui-react";

class SubscribeUserModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.onChange = this.onChange.bind(this);
    this.saveAndExit = this.saveAndExit.bind(this);
  }

  getInitialState() {
    return {
      userSelected: null,
      userSelectedName: ""
    };
  }

  onChange(e, data) {
    let userSelectedName = "";

    if (typeof data.options !== "undefined" && data.options.length > 0) {
      data.options.map(function(item) {
        if (item.value === data.value) {
          userSelectedName = item.text;
        }
      });

      this.setState({
        userSelected: data.value,
        userSelectedName
      });
    }
  }

  saveAndExit() {
    this.props.subscribeOther(this.state.userSelected);
    this.props.subscribingUser(false);
  }

  render() {
    let self = this;

    return (
      <Modal
        open={true}
        onClose={() => {
          this.props.subscribingUser(false);
        }}
        closeIcon
      >
        <Header icon="pin" content="Subscribe Someone Else..." />
        <Modal.Content>
          <div>
            <Grid>
              <Grid.Column width={16}>
                <UserField
                  label="User to Subscribe"
                  userData={null}
                  selectedUser={this.state.userSelected}
                  onChange={(e, data) => self.onChange(e, data)}
                  onReset={self.onReset}
                  limitInstance={this.props.instance}
                />
              </Grid.Column>
            </Grid>
          </div>
          <p>
            {this.state.userSelectedName === "" ? (
              <span>
                Subscribing another user means he or she will receive all future
                notifications for this {this.props.recordNiceName}.
              </span>
            ) : (
              <span>
                When you click <em>Subscribe User, </em>
                {this.state.userSelectedName} will begin receiving notifications
                for this {this.props.recordNiceName}.
              </span>
            )}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={this.saveAndExit}>
            <Icon name="bell" /> Subscribe User
          </Button>
          <Button
            color="grey"
            onClick={() => {
              this.props.subscribingUser(false);
            }}
          >
            <Icon name="dont" /> Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole,
    instance: state.main.instance
  };
}

export default connect(mapStateToProps, null)(SubscribeUserModal);



// WEBPACK FOOTER //
// ./src/components/modals/SubscribeUserModal.js